import { TimePicker } from "@mui/lab";
import { TextField } from "@mui/material";
import { RefObject, useCallback, useEffect } from "react";
import { Dispatch, useState } from "react";
import { FormInput } from "../../../lib/workout-form/transformers";
import { Action, FormInputs } from "../../../reducers/workoutReducer";

type Props = {
  dispatch: Dispatch<Action>;
  loading: boolean;
  startTime: FormInput;
  endTime: FormInput;
  type: FormInputs.startTime | FormInputs.endTime;
  handleErrorRefs: RefObject<(() => void)[]>;
};

const TimeInput = ({
  handleErrorRefs,
  type,
  dispatch,
  loading,
  startTime,
  endTime,
}: Props) => {
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");

  const handleError = useCallback(() => {
    setError(type === FormInputs.startTime ? startTime.error : endTime.error);
    setMessage(
      type === FormInputs.startTime ? startTime.message : endTime.message
    );
  }, [type, startTime, endTime]);

  useEffect(() => {
    handleError();
  }, [startTime.error, endTime.error, handleError]);

  handleErrorRefs.current?.push(handleError);

  const label = type === FormInputs.startTime ? "Startar" : "Slutar";
  const time = type === FormInputs.startTime ? startTime : endTime;

  return (
    <TimePicker
      ampm={false}
      label={label}
      onChange={(e, v) => {
        dispatch({ type: type, payload: e });
      }}
      value={time.input as Date}
      renderInput={(params) => (
        <TextField {...params} error={error} helperText={message} />
      )}
      disabled={loading}
    />
  );
};

export default TimeInput;
